import styled from 'styled-components';

import { Typography } from 'src/typography';
import { fullWidthStyles } from '../hybrid-carousel.styles';

export const GroupHeader = styled.div<{ carouselPadding?: string; fullWidth?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 32px;
  padding: ${({ carouselPadding }: { carouselPadding?: string }) => carouselPadding && `0 ${carouselPadding}px`};
  ${({ fullWidth }) => fullWidth && fullWidthStyles}
`;

export const GroupHeaderInner = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

export const GroupHeaderIcon = styled.div`
  margin-right: 15px;
`;

export const GroupHeaderText = styled.div`
  padding-right: 16px;
`;

export const GroupHeaderActions = styled.div`
  align-items: center;
  display: flex;
`;

export const GroupHeaderLink = styled.a<{ primaryColor?: string; textColor?: string }>`
  color: ${({ primaryColor, textColor }) => textColor ?? primaryColor};
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  text-transform: var(--dct--customized-textTransforms-links);
  transition: color 0.2s;
`;

export const Heading = styled(Typography.Heading)`
  color: var(--dcm-section-title-color);
  font-size: 24px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 20px;
    line-height: 1.2;
  }
`;

export const Subheading = styled(Typography.Body)`
  color: var(--dcm-section-subtitle-color);
  font-family: var(--dcm-font-secondary);
  margin-bottom: 0;
`;
